<template>
  <div>
    <div v-if="show"><GridLoading style="position: relative; z-index: 999999; top: 19rem"></GridLoading></div>
    <div v-else>
      <StyleCreateComp v-if="visible" :visible="visible" @update="update"></StyleCreateComp>
      <EditStyle
        v-if="visibleEdit"
        :visibleEdit="visibleEdit"
        @update="update"
        :editStyleId="editStyleId"
        :duplicateEditId="duplicateEditId"
      ></EditStyle>
      <input
        type="file"
        ref="fileToUpload"
        class="d-none"
        id="fileUpload"
        aria-label="Upload File"
        accept=".xls,.xlsx"
        @change="onFileChange"
      />

      <h5 class="mb-0" style="font-weight: bold">{{ $t("dashboard.styles") }}</h5>
      <div class="header mb-2" style="position: sticky; top: 0; background: white; z-index: 1000; padding: 1rem 0">
        <div style="display: flex; gap: 8px; align-items: center">
          <a
            v-if="tenantSettingsLoaded && !isV4CalculationEngine"
            href="/Multi-ComponentTemplateUpload-v3.xlsx"
            download
            class="btn btn-sm btn-primary mt-0"
            style="
              width: 12rem;
              border-radius: 3px;
              padding: 4px;
              display: inline;
              text-align: center;
              background-color: #0054a6;
              color: white;
              text-decoration: none;
            "
          >
            <span class="fa fa-download" style="font-size: large; margin-right: 7px"></span>
            {{ $t("appSideBar.downloadTemplate") }}
          </a>
          <button
            v-if="tenantSettingsLoaded && !isV4CalculationEngine"
            class="btn btn-sm btn-primary mt-0"
            style="
              width: 12rem;
              border-radius: 3px;
              padding: 4px;
              display: inline;
              text-align: center;
              background-color: #0054a6;
              color: white;
            "
            @click="triggerFileUpload"
          >
            <span class="fa fa-upload" style="font-size: large; margin-right: 7px"></span>
            {{ $t("dashboard.uploadANewStyle") }}
          </button>
        </div>
        <div class="dropdown-wrapper">
          <select
            v-model="selectedReportPrintingOption"
            class="dropdown-left mt-0"
            @change="handleDropdownChange"
            style="
              width: 6rem;
              border-radius: 3px;
              padding: 4px;
              display: inline;
              text-align: center;
              margin-right: 10px;
            "
            aria-label="Report Printing Option"
          >
            <option value="pdf" style="text-align: left; padding-left: 0">PDF</option>
            <option value="csv" style="text-align: left; padding-left: 0">CSV</option>
          </select>
          <button
            class="btn btn-sm btn-primary mt-0"
            style="
              width: 9rem;
              border-radius: 3px;
              padding: 4px;
              display: inline;
              text-align: center;
              background-color: #0054a6;
              color: white;
            "
            @click="addStyleButton"
          >
            <span class="fa fa-plus" style="font-size: large; margin-right: 7px"></span>
            {{ buttonText }}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-4">
          <div class="card" style="border-radius: 10px">
            <div class="card-body">
              <div class="card-text">
                <StyleGrid
                  ref="detailsGrid"
                  :stylesData="stylesData"
                  :totalStylesCount="totalStylesCount"
                  @changeDataHandler="changeDataHandler"
                  @changeFilteredDataHandler="changeFilteredDataHandler"
                  @updatePages="handlePageCount"
                  :perPages="stylesKpiData.styles"
                  :loadingGrid="loadingGrid"
                  @editStyleId="setEditStyleId"
                  @duplicateEditId="setDuplicateEditId"
                ></StyleGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogBox v-if="showModal" :jsondata="jsondata" :importType="1" :title="Title" />
    </div>
  </div>
</template>

<script lang="ts">
import "@progress/kendo-ui";
import { read, utils, WorkBook, WorkSheet } from "xlsx";
import DialogBox from "@/app/views/_components/DialogBox.vue";
import "@progress/kendo-theme-default/dist/all.css";
import StyleGrid from "@/app/views/_components/StyleGrid.vue";
import { StyleApi, UserAdminSettingApi, CustomSettingsApi } from "@/api";
import StyleCreateComp from "@/app/views/_components/StyleCreateComp.vue";
import EditStyle from "@/app/views/_components/EditStyle.vue";
import { eventBus } from "@/main";
import GridLoading from "../_components/GridLoading.vue";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from "vue-router";
import getEnv from "@/core/utils/env";

export default defineComponent({
  name: "Styles",
  setup() {
    const styleApi = new StyleApi()!;
    const userAdminSettingApi = new UserAdminSettingApi()!;
    const customSettingsApi = new CustomSettingsApi()!;

    return {
      styleApi,
      userAdminSettingApi,
      customSettingsApi
    };
  },
  components: {
    DialogBox,
    StyleGrid,
    StyleCreateComp,
    EditStyle,
    GridLoading
  },
  data() {
    return {
      showModal: false,
      parse_header: "",
      jsondata: null as any[] | null,
      stylesData: [] as any,
      loaded: false,
      show: false,
      loadingGrid: false,
      Title: "",
      buttonText: this.$t("dashboard.addStyle"),
      visible: false,
      visibleEdit: false,
      defaultAllowance: "",
      editStyleId: 0,
      duplicateEditId: 0,
      defaultSettingExist: false,
      selectedReportPrintingOption: "pdf",
      stylesKpiData: { styles: 0, customers: 0 } as { styles: number | undefined; customers: number | undefined },
      styleKpiLoaded: false,
      fileToUpload: null as any,
      toast: null as any,
      route: useRoute(),
      router: useRouter(),
      totalStylesCount: 0 as any,
      calculationEngineType: "" as any,
      tenantSettingsLoaded: false
    };
  },
  computed: {
    PROFILE(): string {
      return getEnv("VUE_APP_CD_PLATFORM_PROFILE");
    },
    // GSD V4 tenants don't use the style-upload template flow, so those actions are hidden for them.
    isV4CalculationEngine(): boolean {
      const engineType = String(this.calculationEngineType ?? "")
        .trim()
        .toLowerCase();
      return engineType === "gsdv4";
    }
  },
  created(): void {
    this.toast = useToast();
    this.getDefaultCustomSetting();
    this.onMountGridData();
    this.gettingAdminData();
    eventBus.emit("pageName", "Styles");
  },
  mounted(): void {
    if (this.route.query.error) {
      this.toast.error(this.route.query.error as string, {
        toastClassName: "custom-error-toast",
        timeout: 5000
      });
      this.router.replace({ query: null } as any);
    }
    const storedSelectedReportPrintingOption = localStorage.getItem("selectedReportPrintingOption");
    if (storedSelectedReportPrintingOption) {
      this.selectedReportPrintingOption = storedSelectedReportPrintingOption;
    } else {
      localStorage.setItem("selectedReportPrintingOption", this.selectedReportPrintingOption);
    }
  },
  watch: {
    visibleEdit(newVal) {
      this.editScrollStyle(newVal);
    },
    visible(newVal) {
      this.editScrollStyle(newVal);
    }
  },
  methods: {
    handlePageCount(totalCount: any) {
      this.stylesKpiData.styles = totalCount;
    },
    editScrollStyle(val: any) {
      const body = document.getElementsByTagName("body")[0];
      const html = document.getElementsByTagName("html")[0];
      if (body) {
        body.style.overflow = val ? "hidden" : "";
      }
      if (html) {
        html.style.overflow = val ? "hidden" : "";
      }
    },
    update(): void {
      this.visible = false;
      this.visibleEdit = false;
      this.onMountGridData();
    },
    setEditStyleId(styleId: number): void {
      this.editStyleId = styleId;
      this.visibleEdit = true;
    },
    addStyleButton(): void {
      sessionStorage.setItem("styleId", "");
      this.visible = true;
    },
    triggerFileUpload(): void {
      if (this.$refs.fileToUpload) {
        (this.$refs.fileToUpload as HTMLInputElement).value = "";
        (this.$refs.fileToUpload as HTMLInputElement).click();
      }
    },
    setDuplicateEditId(styleId: number): void {
      this.duplicateEditId = styleId;
      this.visibleEdit = true;
    },
    handleDropdownChange(): void {
      localStorage.setItem("selectedReportPrintingOption", this.selectedReportPrintingOption);
    },
    onFileChange(event: Event): void {
      /* wire up file reader */
      const target = event.target as any;
      if (target.files.length !== 1) {
        throw new Error("Cannot use multiple files");
      }
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(target.files?.[0]);
      reader.onload = (e: any) => {
        /* create workbook */
        const binarystr: string = e.target.result;
        const wb: WorkBook = read(binarystr, { type: "binary" });

        /* selected the first sheet */
        const wsname: string = wb.SheetNames?.[0];
        const ws: WorkSheet = wb.Sheets[wsname];

        const data: any = utils.sheet_to_json(ws, { header: 1, defval: "", blankrows: false }); // to get 2d array pass 2nd parameter as object {header: 1}
        // Data will be logged in array format containing objects
        let rowsData: any = [];
        for (let e of data) {
          let row: any = {};
          let cells: any = [];
          // Iterate over the keys of object
          for (let key of Object.keys(e)) {
            let cell = {
              value: ""
            };
            //Copy the value
            let val = e[key];
            cell.value = val;
            cells.push(cell);
          }
          row["cells"] = cells;
          rowsData.push(row);
        }
        this.jsondata = Object.assign([], rowsData);
        this.showModal = false; // tear down any stale dialog
        this.$nextTick(() => {
          this.showModal = true; // now it's a real change → re-mounts
        });
      };
      this.$nextTick(() => {
        (this.$refs.fileToUpload as HTMLInputElement).value = "";
      });
    },
    async onMountGridData(): Promise<void> {
      this.show = true;
      await this.styleApi
        .apiStyleGridGet("CreationTime", 0, 25)
        .then(async e => {
          this.stylesData = Object.assign([], e.data["items"]);
          eventBus.emit("stylesData", this.stylesData);
          this.stylesKpiData.styles = e.data.totalCount;
          this.totalStylesCount = e.data.totalCount;
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        })
        .finally(() => {
          this.show = false;
        });
    },
    async changeDataHandler(page: number): Promise<void> {
      this.loadingGrid = true;
      await this.styleApi
        .apiStyleGridGet("CreationTime", (page - 1) * 25, 25)
        .then(async e => {
          this.stylesData = Object.assign([], e.data["items"]);
          this.stylesKpiData.styles = e.data.totalCount;
          this.loadingGrid = false;
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        })
        .finally(() => {});
    },
    async changeFilteredDataHandler(page: number, filtersArray: string): Promise<void> {
      this.loadingGrid = true;
      await this.styleApi
        .apiGetFilteredStylesGet(filtersArray, "CreationTime", (page - 1) * 25, 25)
        .then(async e => {
          this.stylesKpiData.styles = e.data.totalCount;
          this.loadingGrid = false;
          let filteredStylesData: any[] = Object.assign([], e.data["items"]);
          for (let item of filteredStylesData) {
            if (typeof item.creationTime === "string") {
              item.creationTime = (this.$refs.detailsGrid as any).convertDate(item.creationTime);
            }
          }
          (this.$refs.detailsGrid as any).updateGrid(filteredStylesData);
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        });
    },
    async getDefaultCustomSetting(): Promise<void> {
      await this.customSettingsApi.apiGetDefaultUserCustomSettingGet().then((res: any) => {
        sessionStorage.setItem("tktTexValue", res.data.tktTex as string);
        sessionStorage.setItem("defaultCustomSettingName", res.data.name);
        sessionStorage.setItem("defaultAllowance", res.data.defaultAllowance as string);
        sessionStorage.setItem("defaultCustomSettingId", res.data.id as unknown as string);
      });
    },
    async gettingAdminData(): Promise<void> {
      await this.userAdminSettingApi.apiSystemConfigurationGet().then(async res => {
        sessionStorage.setItem("seamLengthUnit", res.data["seamLengthUnit"]?.defaultItem as string);
        sessionStorage.setItem("packageUnitVal", res.data["packageUnit"]?.defaultItem as string);
        sessionStorage.setItem("customSettingToggleValue", res.data.customSettingToggleValue as string);
        this.calculationEngineType = res.data.calculationEngineType?.defaultItem ?? "";
        this.Title = (this.$t("dialogBox.dataUpload") +
          "    (" +
          this.$t("dialogBox.lengthMeasurementUnit") +
          " : " +
          sessionStorage.getItem("seamLengthUnit") +
          ")" +
          " (" +
          this.$t("dialogBox.allowance") +
          " : " +
          sessionStorage.getItem("defaultAllowance") +
          ")" +
          " (" +
          sessionStorage.getItem("tktTexValue") +
          ")") as string;
        this.tenantSettingsLoaded = true;
      });
    }
  }
});
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.report-select {
  width: 6rem;
  border-radius: 3px;
  padding: 4px;
  display: inline;
  text-align: center;
  margin-right: 10px;
}
.toolbar-btn {
  border-radius: 3px;
  display: inline;
  text-align: center;
  background-color: #0054a6;
  color: white;
}
.toolbar-btn--add {
  width: 9rem;
  padding: 4px;
}
.toolbar-btn--upload {
  min-width: 9rem;
  padding: 4px 12px;
  white-space: nowrap;
  margin-right: 10px;
}
.custom-success-toast {
  background-color: #cfedeaf8 !important;
  color: #216b5d !important;
  font-size: 14px !important;
  width: 400px;
}
.custom-error-toast {
  background-color: #f6dde2f2 !important;
  color: #7f323b !important;
  font-size: 14px !important;
  width: 400px;
}
.Vue-Toastification__container {
  z-index: 12002 !important;
  position: fixed;
  padding: 4px;
  box-sizing: border-box;
  display: flex;
  min-height: 100%;
  color: #fff;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
}
.Vue-Toastification__close-button {
  color: rgb(8, 8, 8) !important;
}
body {
  font-family: Arial, Helvetica, sans-serif !important;
}
.dropdown-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
